import React from 'react'

import image1 from 'assets/tutorial-1.png'
import image2 from 'assets/tutorial-2.png'
import image3 from 'assets/tutorial-3.png'
type Props = {}

const images = {
  image1: image1,
  image2: image2,
  image3: image3,
}
const useDocumentationPage = (props: Props) => {
  
  const [activeScreen, setActiveScreen] = React.useState(0)

  return {
    activeScreen,
    setActiveScreen,
    images,
  }

}

export default useDocumentationPage